import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=f1a0282c&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"
import style0 from "./Files.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Files.vue?vue&type=style&index=1&id=f1a0282c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a0282c",
  null
  
)

export default component.exports